import type { TFunction } from 'i18next';
import { countries } from '@app/constants/countries.constants';
import { Namespace } from '@data/utils/enums';

const translationKeyByName = new Map(Object.entries(countries).map(([key, name]) => [name, key]));

/** A stored English country name in the reader's language; a name the country list lacks stays as it is. */
export const getCountryLabel = (country: string, t: TFunction): string => {
  const translationKey = translationKeyByName.get(country);
  return translationKey ? t(translationKey, { ns: Namespace.COUNTRIES }) : country;
};
